module.exports = __webpack_public_path__ + "img/googledrive.47f8ec17.png";